import React from 'react';
import { Form, Input, Button, message, Select } from 'antd';
import InputRules from '../../../data/InputRules';

const layout = {
	labelCol: {
		span: 6,
	},
	wrapperCol: {
		span: 7,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 6,
		span: 16,
	},
};

const VehicleFeatureEditForm = ({ feature, updateFeatureList, updateVehicleFeature, setEditModal }) => {
	const onFinish = async (values) => {
		await updateVehicleFeature(feature._id, values);
		updateFeatureList();
		setEditModal();
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	return (
		<Form
			{...layout}
			name="vehicle-feature-form"
			onFinish={onFinish}
			initialValue={{ remember: false }}
			onFinishFailed={onFinishFailed}
		>
			<Form.Item label="Features" name="features" rules={InputRules.required('Please input features!')}>
				<Select mode="tags" defaultValue={feature?.features} style={{ width: '300px' }} />
			</Form.Item>
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Update Vehicle Feature
				</Button>
			</Form.Item>
		</Form>
	);
};

export default VehicleFeatureEditForm;
